module.exports = __webpack_public_path__ + "images/frontpage_autoplay@3x.png?ff845b3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_autoplay@3x.png
// module id = 629
// module chunks = 7